import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Home from "./App";
import PropertyDetails from "./PropertyDetails";
import PropertiesList from "./AllProperties";
import ContactUs from "./ContactUs";
import Gallery from "./Gallery";
import Layout from "./Layout";
import Careers from "./Careers";
// import FinanceCalculator from "./FinanceCalculator";
import FinanceCalculator from "./BgCalculator";
import ScrollToTop from "./ScrollToTop";
// Property Type Pages
import IndustrialProperties from "./IndustrialProperties";
import ResidentialProperties from "./ResidentialProperties";
import CommercialProperties from "./CommercialProperties";
import LandProperties from "./LandProperties";
import LatestProperties from "./LatestProperties";
import FeaturedProperties from "./FeaturedProperties";
import PrivacyPolicy from "./PrivacyPolicy2";
import TermsConditions from "./TermsCondition2";
import YouTubeThumbnails from "./YouTube";
import PropertyEnquiry from "./PropertyEnquiry";
// New Components for Circular Navigation
import QrCode from "./QrCode";


import About from "./About";

export default function AppRoutes() {
  return (
    <BrowserRouter>

      <ScrollToTop /> {/* 🡐 Scroll helper */}
      <Routes>

        <Route element={<Layout />}>

        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/property/:id" element={<PropertyDetails />} />
        <Route path="/propertie" element={<PropertiesList />} />
        
        {/* Property Type Pages */}
        <Route path="/properties/industrial" element={<IndustrialProperties />} />
        <Route path="/properties/residential" element={<ResidentialProperties />} />
        <Route path="/properties/commercial" element={<CommercialProperties />} />
        <Route path="/properties/land" element={<LandProperties />} />
          <Route path="/properties/LatestProperties" element={<LatestProperties />} />
          <Route path="/FeaturedProperties" element={<FeaturedProperties />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/FinanceCalculator" element={<FinanceCalculator />} />
          <Route path="/TermsConditions" element={<TermsConditions />} />
          <Route path="/PropertyEnquiry" element={<PropertyEnquiry />} />
        
        {/* Other Pages */}
        <Route path="/about" element={<About />} />
          <Route path="/ContactUs" element={<ContactUs />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/Careers" element={<Careers />} />
          <Route path="/YouTubeThumbnails" element={<YouTubeThumbnails />} />
          <Route path="/QrCode" element={<QrCode/>} />
        {/* 404 Page */}
        {/* <Route path="*" element={<h1>404 - Page Not Found</h1>} /> */}
       <Route path="*" element={<Home />} />

        </Route>



      </Routes>
    </BrowserRouter>
  );
}